import React from 'react';
import $$ from 'cmn-utils';
import config from '@/config';

/**
 * 自定义素材组件
 * 
 * 加载本地文件路径  let src = 'assets/images/xxx/xxx.png';  以'assets/'开始
 * 加载服务器文件路径  let src = `${ele.preview}`; 不以'assets/'开始
 *
 */
class Material extends React.Component {
  static propTypes = {
    //src: PropTypes.string.isRequired,
  };

  static defaultProps = {
    
  };

  // ObjectURL 的Map，用于标记缓存的blob文件，组件被卸载时需要释放
  _objectURLMap = new Map();

  constructor(props){
    super(props);

    this.state = {
      src: "",
      poster: ""
    };
  }

  /**
   * 加载服务器文件方法
   * @param {url} url 请求链接
   * @param {headers} headers 请求头对象，可以不传
   */
  loadServerFile(url, headers = {
    "Content-Type": "application/x-www-form-urlencoded"
  }) {
    //文件未被加载，需发请求加载
    if (!this._objectURLMap.get(url)) {
      //给请求头传token
      //headers.token = $$.getStore("token");
      headers.token = window.sessionStorage.getItem('token');

      const target = config.request.prefix + '/resource/loadResource?time=' + new Date().getTime() + '&filePath=' + url;

      fetch(target,{
        method: "GET",
        headers
      }).then(response => response.blob().then(blob => {
        if (response.status === 200) {          
          //URL.createObjectURL()方法会根据传入的参数创建一个指向该参数对象的URL。
          //这个URL的生命仅存在于它被创建的这个文档里，新的对象URL指向执行的File对象或者是Blob对象。
          //如果你不再需要这个对象，需要使用URL.revokeObjectURL()方法释放它。
          const isloadUrl = window.URL.createObjectURL(blob);

          this._objectURLMap.set(url, isloadUrl);

          this.setState({
            src: isloadUrl
          });
        } else {
          const notice = config.notice;
          notice.error(window.language['conmmon.search.error'] + response.status);
        }
      })).catch((error) => {
        const notice = config.notice;
        notice.error(window.language['conmmon.search.error'] + error);
      });
    } else {//文件已被加载，无需再次请求
      this.setState({
        src: this._objectURLMap.get(url)
      });
    }
  }

  /** 视频加载第一帧图片 */
  loadPosterFile(url, headers = {
    "Content-Type": "application/x-www-form-urlencoded"
  }) {
    //文件未被加载，需发请求加载
    if (!this._objectURLMap.get(url)) {
      //给请求头传token
      //headers.token = $$.getStore("token");
      headers.token = window.sessionStorage.getItem('token');

      const target = config.request.prefix + '/resource/loadResource?time=' + new Date().getTime() + '&filePath=' + url;

      fetch(target,{
        method: "GET",
        headers
      }).then(response => response.blob().then(blob => {
        if (response.status === 200) {
          //URL.createObjectURL()方法会根据传入的参数创建一个指向该参数对象的URL。
          //这个URL的生命仅存在于它被创建的这个文档里，新的对象URL指向执行的File对象或者是Blob对象。
          //如果你不再需要这个对象，需要使用URL.revokeObjectURL()方法释放它。
          const isloadUrl = window.URL.createObjectURL(blob);

          this._objectURLMap.set(url, isloadUrl);

          this.setState({
            poster: isloadUrl
          });
        } else {
          const notice = config.notice;
          notice.error(window.language['conmmon.search.error'] + response.status);
        }
      })).catch((error) => {
        const notice = config.notice;
        notice.error(window.language['conmmon.search.error']+ error);
      });
    } else {//文件已被加载，无需再次请求
      this.setState({
        poster: this._objectURLMap.get(url)
      });
    }
  }

  /**
   * 加载本地文件方法
   * @param {url} url 请求链接
   * @param {headers} headers 请求头对象，可以不传
   */
  loadLocalFile(url) {
    this.setState({
      src: require(`assets/`+url.substring(7)), // 静态分析，moduleId必须是字符串常量，而不可以是含变量的表达式，但webpack支持简单的不含变量的表达式和含变量的简单表达式
    });
  }

  loadFile(src, poster){
    if (src) {
      //本地文件必须以'assets/'开始
      if(src.indexOf('assets/') === 0){
        this.loadLocalFile(src);
      }else{
        // this.loadServerFile(src);
        // if (poster) {
        //   this.loadPosterFile(poster);
        // }
        let prefix = config.request.prefix + '/resource/loadResource?time=' + new Date().getTime() + '&filePath=';
        src = prefix + src;
        this.setState({
          src
        });
        if (poster) {
          poster = prefix + poster;
          this.setState({
            poster
          });
        }
      }
    }else{
      this.setState({
        src: null
      });
    }
  }
  /**
   * 当props发生变化时执行，初始化render时不执行，
   * 在这个回调函数里面，你可以根据属性的变化，通过调用this.setState()来更新你的组件状态，
   * 旧的属性还是可以通过this.props来获取,这里调用更新状态是安全的，并不会触发额外的render调用
   * 
   * @param {nextProps} nextProps 新的属性对象
   */
  componentWillReceiveProps(nextProps) {
    const { src, poster } = nextProps;
    if (
      nextProps.src !== this.props.src
    ) {
      this.setState({
        src: null,
        poster: null,
      }, () => {
        this.loadFile(src, poster);
      })
    }
  }

  /**
   * 当组件要从界面上装载渲染的时候，就会调用 componentWillMount()，
   * 执行一次，在初始化render之前执行，
   * 如果在这个方法内调用setState，render()知道state发生变化，并且只执行一次
   */
  componentWillMount() {
    let { src, poster } = this.props;

    this.loadFile(src, poster);
  }

  /**
   * 当组件要被从界面上卸载移除的时候，就会调用 componentWillUnmount()，
   * 在这个函数中，可以做一些组件相关的清理工作，例如取消计时器、网络请求等
   * 注意：如果 componentWillUnmount() 没有被触发，很有可能是因为你用了 路由router 而没有对其中路由栈参数做配置
   */
  componentWillUnmount() {
    /**
     * react中切换路由时报 Can't call setState (or forceUpdate) on an unmounted component. 错误
     * 实际的原因是因为在组件挂载（mounted）之后进行了异步操作，比如ajax请求或者设置了定时器等，而你在callback中进行了setState操作。
     * 当你切换路由时，组件已经被卸载（unmounted）了，此时异步操作中callback还在执行，因此setState没有得到值。
     * 有三种方式解决：
     * 1.在卸载的时候对所有的操作进行清除（例如：abort你的ajax请求或者清除定时器）
     * 2.设置一个flag，当unmount的时候重置这个flag，然后在异步请求的回调函数做判断组件是否卸载
     * 3.下面用最简单的方式处理（万金油）
     */
    this.setState = (state, callback) => {
      return;
    };

    this._objectURLMap.forEach((value, key, map) => {
      //每次调用createObjectURL时，即使你已经为同一个文件创建过一个URL，也会创建一个新的URL对象。
      //如果你不再需要这个对象，需要使用URL.revokeObjectURL()方法释放它。
      //虽然当页面被关闭，浏览器会自动释放它，但是为了最佳性能和内存使用，当确保不再用得到它时，就应该释放它。
      window.URL.revokeObjectURL(value);
    });
  }

  /**
   * 在第一次render渲染后调用，只在客户端。之后组件已经生成了对应的DOM结构，可以通过this.getDOMNode()来进行访问。 
   * 如果你想和其他JavaScript框架一起使用，可以在这个方法中调用setTimeout, setInterval
   * 或者发送AJAX请求等操作(防止异步操作阻塞UI)。
   */
  componentDidMount() {
    
  }
}

export default Material;



// WEBPACK FOOTER //
// ./src/components/Material/Material.js